import React from 'react';
import {Grid} from "@mui/material";
import {CompPartSelector as PartSelector} from "../../components/PartSelector";
import {Application} from "../../application/MainApp";
import {ContentIdentifierPageForm} from "./components/contentIdentifierPage";
import {connect} from "react-redux";
import {setBreadcrumbs} from "../root/root.actions";
import {withTranslation} from "react-i18next";
import {unsetContentIdentifier} from "./contentIdentifier.actions";
import { withRouter } from '../utils/withRouter.js';

class ContentIdentifierComponent extends React.Component {
    constructor(props) {
        super(props);
        props.setBreadcrumbs(props.match);
        this.state = {
            activeTab: "ownMunicipality",
        }
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    componentDidMount() {
        document.title = this.props.t('common.content_identifiers') + " - " + this.props.t('common.title');
    }

    handleTabChange(selection) {
        this.props.unsetContentIdentifier();
        this.setState({...this.state, activeTab: selection});
    }
    
    render() {
        //let page = (<ContentIdentifierPageForm page={this.state.activeTab}/>)
        const {t} = this.props;
        return (
            <Application>
                <Grid container>
                    <Grid size={12}>
                        <PartSelector
                            selectors={[
                                {
                                    'key': "ownMunicipality",
                                    'label': t('content_identifier.own_municipality')
                                },
                                {
                                    'key': "nationwide",
                                    'label': t('content_identifier.nationwide')
                                }
                            ]}
                            onSelect={this.handleTabChange}
                        />
                    </Grid>
                </Grid>
                <ContentIdentifierPageForm activeTab={this.state.activeTab} page={this.state.activeTab}/>
            </Application>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setBreadcrumbs: (match) => dispatch(setBreadcrumbs(match)),
        unsetContentIdentifier: () => dispatch(unsetContentIdentifier()),
    };
}


const ContentIdentifier = connect(
    null,
    mapDispatchToProps
)(withTranslation('translation')(withRouter(ContentIdentifierComponent)));

export {ContentIdentifier};